import {
  Button,
  Icon,
  PhoneMockup,
  PhoneMockupLayout,
  Text,
} from '@frontend/ui-library';
import { BillDetailHeader } from '../../components';
import BuyerInfoForm from './BuyerInfoForm';

import { ReactComponent as QuestionSvg } from '@frontend/icons/question.svg';

import styles from './BuyerInfo.module.css';
import { PageFields_BuyerDetailsUpdatePage_Fragment as BuyerDetailsUpdatePageFragment } from '../../graphql/generated';
import { links } from '../../constants';
import { useWidgetContext } from '../../context/WidgetContext';
import { useEffect } from 'react';
import { getIdFromUrl } from '@frontend/utils';
import { isOfframpBill } from '../../utils';

interface BuyerInfoProps {
  data: BuyerDetailsUpdatePageFragment['pageData'];
}

function BuyerInfo({ data }: BuyerInfoProps) {
  const { configureHeader } = useWidgetContext();

  useEffect(() => {
    configureHeader({
      id: getIdFromUrl(),
      merchantName: data.merchantName,
      expiresAt: data.expiresAt,
      allowClosePayment: true,
      billType: data.billType,
    });
  }, []);

  const isOffRamp = isOfframpBill(data.billType);

  return (
    <PhoneMockupLayout>
      <PhoneMockup
        header={
          <BillDetailHeader
            isOffRamp={isOffRamp}
            amount={data.buyerDetailsUpdatePageFiatAmount}
            currency={data.fiatCurrency}
          />
        }
      >
        <Text
          mt="0"
          mb="0"
          as="h1"
          size="big"
          weight="700"
          color="royal-700"
          align="center"
        >
          Basic details
        </Text>
        <Text
          mt="8"
          mb="0"
          as="p"
          size="small"
          color="neutral-500"
          align="center"
        >
          Travel Rule regulations require the following information:
        </Text>
        <Button
          className={styles['info-button']}
          as="a"
          mt="8"
          size="small"
          variant="ghost"
          rightIcon={<Icon component={<QuestionSvg />} />}
          href={links.support.TRAVEL_RULE}
          target="_blank"
        >
          What is travel rule
        </Button>
        <BuyerInfoForm data={data} />
      </PhoneMockup>
    </PhoneMockupLayout>
  );
}

export default BuyerInfo;
